import { Button, DatePicker, Form, InputNumber, Modal } from 'antd'
import { ProductApi } from 'api/Product'
import FooterButtons from 'elements/Buttons/FooterButtons'
import useFetch from 'elements/Hooks/useFetch'
import useModalShow from 'elements/Hooks/useModalShow'
import useSubmit from 'elements/Hooks/useSubmit'
import CustomTable from 'elements/Table/CustomTable'
import { defaultFormItemLayout } from 'modules/FormItems'
import moment from 'moment'
import React, { useState } from 'react'

export function PriceHistory({ id, type }) {
  const { visible, onShow, onCancel: _onCancel, isNew } = useModalShow()
  const [current, setCurrent] = useState({})
  const { data, fetching, fetch } = useFetch({
    url: `/products/line/${id}`,
    dependencyArray: [id],
  })

  const [priceUpdating, priceFunc] = useSubmit(ProductApi.lines.update)

  const list = data?.history?.[type] || []

  function onCancel(props) {
    setCurrent({})
    _onCancel(props)
  }

  async function submit() {
    console.log('submit', current)
    let newData = [...list]
    newData.push(current)
    await priceFunc({
      ...data,
      history: {
        ...data?.history,
        [type]: newData,
      },
    })
    onCancel()
  }

  async function remove() {
    console.log('remove', current)
    let newData = [...list]
    newData = newData.filter((i) => i.date !== current.date)
    await priceFunc({
      ...data,
      history: {
        ...data?.history,
        [type]: newData,
      },
    })
    onCancel()
  }

  async function update() {
    console.log('update', current)
    let newData = [...list]
    newData = newData.map((i) => (i.date === current.date ? current : i))
    await priceFunc({
      ...data,
      history: {
        ...data?.history,
        [type]: newData,
      },
    })
    onCancel()
  }

  const columns = [
    {
      Header: 'Date',
      accessor: 'date',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
    },
  ]

  return (
    <div>
      <Modal
        footer={
          <FooterButtons
            isNew={isNew}
            isEdit={!isNew}
            submit={submit}
            remove={remove}
            update={update}
            title={'Price History'}
          />
        }
        title="Price History 2"
        onCancel={onCancel}
        destroyOnClose
        visible={visible}>
        <Form.Item {...defaultFormItemLayout} label="Date">
          <DatePicker
            onChange={(e) =>
              setCurrent({
                ...current,
                date: moment(e).format('YYYY-MM-DD'),
              })
            }
          />
        </Form.Item>
        <Form.Item {...defaultFormItemLayout} label="Rate">
          <InputNumber
            onChange={(e) =>
              setCurrent({
                ...current,
                rate: e,
              })
            }
          />
        </Form.Item>
      </Modal>
      <CustomTable
        columns={columns}
        data={list}
        fetch={fetch}
        fetching={fetching}
        CreateButton={() => (
          <Button type="primary" onClick={onShow}>
            New Price
          </Button>
        )}
      />
    </div>
  )
}
